<template>
    <HowItWorks :blok="blok" />
</template>

<script setup lang="ts">
import HowItWorks from '~/components/sections/HowItWorks.vue';
import type { IHowItWorks } from '~/../types/HowItWorks';

defineProps<{ blok: IHowItWorks }>();
</script>

<style lang="postcss" scoped></style>
